import {
  SearchPolicyRequest,
  SearchPolicyResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

const policySearch = async (requestBody: SearchPolicyRequest) => {
  const { data } = await axios.post<SearchPolicyResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/search`,
    requestBody
  );
  return data;
};

export const usePolicySearchMutation = () =>
  useMutation({
    mutationFn: (requestBody: SearchPolicyRequest) => policySearch(requestBody),
  });
